import * as React from 'react';
import isEmpty from 'lodash/isEmpty';

import BarChartProgress from 'components/graphs/bar-chart-progress/BarChartProgress';

import { __t, applyTranslations } from 'utils/language';

import './campaign-visibility-chart.scss';

import type { BarChartProgressItem } from 'types';

applyTranslations(require('./campaign-visibility-chart.i18n.json'));

type Props = {
  visibilityGraphItems: Array<BarChartProgressItem>,
  xAxisSeries: Array<string>,
  isLoading: boolean
};

const X_AXIS_GAP_LENGTH = 14;
export const X_AXIS_LENGTH = X_AXIS_GAP_LENGTH * 4;

const CampaignVisibilityChart = (props: Props) => {
  const { visibilityGraphItems, xAxisSeries, isLoading } = props;

  return (
    <div className="campaign-visibility-chart">
      { !isEmpty(visibilityGraphItems) && <div className="campaign-visibility-chart__y-axis" /> }
      <BarChartProgress
        data={visibilityGraphItems}
        title={__t('campaign_visibility_chart.visibility_title')}
        barStyle={{
          title: { marginBottom: 24 },
          container: { marginBottom: 42 },
          label: { width: 80 },
          height: 40
        }}
        isLoading={isLoading}
        emptyMessageWrapperClass="campaign-visibility-chart__empty-message"
        isMetricAlignmentLeft
      />
      {
        !isEmpty(visibilityGraphItems) && (
          <div className="campaign-visibility-chart__x-axis">
            <div className="campaign-visibility-chart__x-axis-label">
              <div className="campaign-visibility-chart__x-axis-marker campaign-visibility-chart__x-axis-marker--visibility-hidden" />
              0
            </div>
            {
                xAxisSeries.map((seriesMarker, index) => (
                  <div className="campaign-visibility-chart__x-axis-label-container" key={`${seriesMarker}-${index}`}>
                    <div className="campaign-visibility-chart__x-axis-label">
                      <div className="campaign-visibility-chart__x-axis-marker" />
                      {seriesMarker}
                    </div>
                  </div>
                ))
              }
          </div>
        )
      }
    </div>
  );
};

export default CampaignVisibilityChart;
